/* eslint-disable arrow-body-style */

export function addSubMenuEspecID(idSubMenuEspec) {
  return {
    type: 'ADD_SUB_MENU_ESPEC_ID',
    idSubMenuEspec,
  };
}

export function addModuloSubMenuID(idModuloSubMenu) {
  return {
    type: 'ADD_MODULO_SUB_MENU_ID',
    idModuloSubMenu,
  };
}

export function addMenuSubMenuID(idMenuSubMenu) {
  return {
    type: 'ADD_MENU_SUB_MENU_ID',
    idMenuSubMenu,
  };
}

export function addSubMenuID(idSubMenu) {
  return {
    type: 'ADD_SUB_MENU_ID',
    idSubMenu,
  };
}
